import { CheckCircle2, Clock, PlayCircle, Wrench, AlertTriangle, Info } from "lucide-react";

const STATUS_STYLES = {
  geplant: {
    label: "Geplant",
    icon: Clock,
    className: "bg-blue-50 text-blue-700 border-blue-200",
  },
  aktiv: {
    label: "Aktiv",
    icon: PlayCircle,
    className: "bg-emerald-50 text-emerald-700 border-emerald-200",
  },
  abgeschlossen: {
    label: "Abgeschlossen",
    icon: CheckCircle2,
    className: "bg-slate-100 text-slate-700 border-slate-200",
  },
};

const CATEGORY_STYLES = {
  wartung: {
    label: "Wartung",
    icon: Wrench,
    className: "bg-orange-50 text-orange-700 border-orange-200",
  },
  stoerung: {
    label: "Störung",
    icon: AlertTriangle,
    className: "bg-red-50 text-red-700 border-red-200",
  },
  information: {
    label: "Information",
    icon: Info,
    className: "bg-indigo-50 text-indigo-700 border-indigo-200",
  },
};

export function StatusBadge({ status }) {
  const cfg = STATUS_STYLES[status] || STATUS_STYLES.geplant;
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border ${cfg.className}`}
      data-testid={`status-badge-${status}`}
    >
      <Icon className="h-3 w-3" />
      {cfg.label}
    </span>
  );
}

export function CategoryBadge({ category }) {
  const cfg = CATEGORY_STYLES[category] || CATEGORY_STYLES.information;
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium border ${cfg.className}`}
      data-testid={`category-badge-${category}`}
    >
      <Icon className="h-3 w-3" />
      {cfg.label}
    </span>
  );
}
